/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lead_List_Delete_ConfirmInputs */

const cs_lead_list_delete_confirm = /** @type {(inputs: Lead_List_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat tento lead? Tuto akci nelze vrátit.`)
};

const en_lead_list_delete_confirm = /** @type {(inputs: Lead_List_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this lead? This cannot be undone.`)
};

/**
* | output |
* | --- |
* | "Delete this lead? This cannot be undone." |
*
* @param {Lead_List_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lead_list_delete_confirm = /** @type {((inputs?: Lead_List_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lead_List_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lead_list_delete_confirm(inputs)
	return cs_lead_list_delete_confirm(inputs)
});